var map = {
	"./bag.png": [
		1627,
		1627
	],
	"./ball.png": [
		6473,
		6473
	],
	"./bat.png": [
		8275,
		8275
	],
	"./box.png": [
		414,
		414
	],
	"./bug.png": [
		1237,
		1237
	],
	"./call.png": [
		9148,
		9148
	],
	"./can.png": [
		3924,
		3924
	],
	"./dog.png": [
		6525,
		6525
	],
	"./doll.png": [
		3151,
		3151
	],
	"./edge.png": [
		9126,
		9126
	],
	"./fan.png": [
		1948,
		1948
	],
	"./fish.png": [
		2016,
		2016
	],
	"./fox.png": [
		4237,
		4237
	],
	"./gum.png": [
		1995,
		1995
	],
	"./ham.png": [
		4061,
		4061
	],
	"./hat.png": [
		2781,
		2781
	],
	"./hip.png": [
		6549,
		6549
	],
	"./jam.png": [
		4297,
		4297
	],
	"./jump.png": [
		6740,
		6740
	],
	"./kit.png": [
		2847,
		2847
	],
	"./leg.png": [
		5550,
		5550
	],
	"./log.png": [
		9160,
		9160
	],
	"./map.png": [
		1101,
		1101
	],
	"./nest.png": [
		6633,
		6633
	],
	"./net.png": [
		7044,
		7044
	],
	"./pan.png": [
		9925,
		9925
	],
	"./pig.png": [
		5766,
		5766
	],
	"./quack.png": [
		7125,
		7125
	],
	"./ram.png": [
		4356,
		4356
	],
	"./six.png": [
		7844,
		7844
	],
	"./sun.png": [
		5288,
		5288
	],
	"./tent.png": [
		5949,
		5949
	],
	"./up.png": [
		8009,
		8009
	],
	"./vest.png": [
		915,
		915
	],
	"./wall.png": [
		4309,
		4309
	],
	"./web.png": [
		1993,
		1993
	],
	"./well.png": [
		7581,
		7581
	],
	"./zip.png": [
		8683,
		8683
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 616;
module.exports = webpackAsyncContext;